// src/admin/adminNotificationsApi.ts
import { apiClient } from "@maat/api-base";
var adminNotificationsApi = {
  getTemplates: async (params) => {
    return apiClient.get("/notifications/api/admin/templates", { params });
  },
  getTemplate: async (id) => {
    return apiClient.get(`/notifications/api/admin/templates/${id}`);
  },
  updateTemplate: async (id, payload) => {
    return apiClient.patch(`/notifications/api/admin/templates/${id}`, payload);
  },
  previewTemplate: async (id, payload) => {
    return apiClient.post(`/notifications/api/admin/templates/${id}/preview`, payload);
  },
  getAnalyticsSummary: async (months) => {
    return apiClient.get("/notifications/api/admin/analytics/summary", {
      params: months !== void 0 ? { months } : {}
    });
  },
  getAnalyticsTimeseries: async (months, template_key) => {
    return apiClient.get("/notifications/api/admin/analytics/timeseries", {
      params: { months, ...template_key ? { template_key } : {} }
    });
  }
};

export {
  adminNotificationsApi
};
